export default {
      id: "i-advantages-desktop-03-usage",
      viewBox: "0 0 683 600",
      url: __webpack_public_path__ + "img/sprite.svg#i-advantages-desktop-03",
      toString: function () {
        return this.url;
      }
    }